<template>
  <div class="e-preview m" v-swipeup="swipeupHandle" v-swipedown="swipedownHandle">
    <div v-if="lessonInfo" class="e-preview-header m" :style="{backgroundImage: `url(${lessonInfo.iteminfo.thumb1})`}">
      <p class="title">{{lessonInfo.iteminfo.title}}</p>
      <p class="desc">{{lessonInfo.iteminfo.introduction}}</p>
      <plan class="plan-group" style="display: none" :lessonInfo="lessonInfo" :signUpInfo.sync="signUpInfo"/>
      <div class="btn-group">
        <a class="join" @click="getTopUrl">{{getTopBtnStr}}</a>
        <a class="contact" @click="dialogVisible = true">课程咨询</a>
      </div>
      <div class="logo-group" v-if="getBrands">
        <p>与知名企业联合制作</p>
        <ul>
          <li v-for="(company, companyIndex) in getBrands" :key="'company-' + companyIndex">
            <img :src="`http://docs-download.oss-cn-shanghai.aliyuncs.com/aiimooc_college/${company}.png`" alt="">
          </li>
        </ul>
      </div>
    </div>
    <ul class="e-preview-fast" ref="scroll-btns">
      <li @click="navClickHandle('introduction')" :class="active === 'introduction' ? 'active' : ''">课程介绍</li>
      <li @click="navClickHandle('characteristic')" :class="active === 'characteristic' ? 'active' : ''">特色服务</li>
      <li @click="navClickHandle('content')" :class="active === 'content' ? 'active' : ''">课程内容</li>
      <li @click="navClickHandle('problem')" :class="active === 'problem' ? 'active' : ''">常见问题</li>
    </ul>
    <ul class="e-preview-imgs" ref="scroll-imgs" v-if="plug && plug.mobile">
      <li id="introduction">
        <img :src="plug.mobile.introduction" alt="">
      </li>
      <li id="characteristic">
        <img :src="plug.mobile.characteristic" alt="">
      </li>
      <li id="content">
        <img :src="plug.mobile.content" alt="">
      </li>
      <li id="problem">
        <img :src="plug.mobile.problem" alt="">
      </li>
    </ul>
    <div class="e-preview-price" :class="showPrice ? 'show' : ''" v-if="lessonInfo">
      <div class="info">
        <p class="title">{{ lessonInfo.iteminfo.title }}</p>
        <p class="price">￥{{ lessonInfo.iteminfo.price }}</p>
      </div>
      <a class="join" @click="getTopUrl">{{getTopBtnStr}}</a>
    </div>
    <el-dialog
      custom-class="e-preview-dialog m"
      center
      width="95%"
      :visible.sync="dialogVisible"
      modal-append-to-body>
      <img v-if="plug" :src="plug.introductionInfo.ewm" alt="">
    </el-dialog>
  </div>
</template>

<script>
import Plan from '@/components/preview/plan'
import api from '@/api/index'

export default {
  props: ['editPlug'],
  data () {
    return {
      signUpInfo: null,
      lessonInfo: null,
      isbuy: false,
      plug: null,
      dialogVisible: false,
      active: '',
      showPrice: false,
      disable: false
    }
  },
  components: {
    Plan
  },
  // directives: {
  //   swipenav: {
  //     bind (el, binding, vnode, oldVnode) {
  //       el.addEventListener('scroll', function (e) {
  //         console.log(el.scrollTop)
  //       })
  //     }
  //   }
  // },
  computed: {
    getTopBtnStr () {
      if (this.isbuy) {
        return '进入教室'
      } else if (this.signUpInfo && this.signUpInfo.type === 1) {
        return '课程咨询'
      } else {
        return '课程咨询'
      }
    },
    getBrands () {
      if (this.lessonInfo.iteminfo.brand && this.lessonInfo.iteminfo.brand.length) {
        return this.lessonInfo.iteminfo.brand.split(',')
      } else {
        return false
      }
    }
  },
  methods: {
    swipeupHandle () {
      this.showPrice = false
    },
    swipedownHandle () {
      this.showPrice = true
    },
    getTopUrl() {
      if (this.$store.state.userInfo === 'false') {
        window.location.href = "https://www.aiimooc.com/mobile/login.php?forward=" + window.location.href
        return false
      }
      if (this.isbuy && !this.disable) {
        this.$router.push(`/m/program/${this.$route.params.id}`)
        return
      }
      if (this.signUpInfo.type === 1) {
        this.dialogVisible = true
      } else {
        if (this.$store.state.userInfo !== 'false') {
          if (!this.isbuy) {
            window.location.href=`https://www.aiimooc.com/mall/buy.php?itemid=${this.$route.params.id}&forward=${decodeURI(window.location.href)}&type=college`
          }
        } else {
          window.location.href=`https://www.aiimooc.com/member/login.php?forward=${decodeURI(window.location.href)}`
        }
      }
    },
    async getLessonInfo () {
      let response = await api.getPreviewData(this.$route.params.id)
      if (response) {
        this.lessonInfo = response.data
      }
      if (response.data.isbuy) {
        this.isbuy = true
      }
    },
    async getPlug () {
      let ajaxPlug = await api.getPlug(this.$route.params.id)
      if (!this.editPlug) {
        if (ajaxPlug.data) {
          ajaxPlug = JSON.parse(ajaxPlug.data.replace(/&quot;/g, '"'))
        } else {
          ajaxPlug = null
        }
        this.plug = ajaxPlug
      } else {
        this.plug = this.editPlug
      }
    },
    navClickHandle (id) {
      const offsetTop = document.querySelector(`#${id}`).offsetTop
      document.querySelector('#m-app').scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      })
    }
  },
  created () {
    this.getLessonInfo()
    this.getPlug()
    this.disable = this.$route.query.disable
  }
}
</script>

<style lang="scss" scoped>
.e-preview.m{
  min-width: 0px;
  position: absolute;
  overflow: auto;
  margin-top: 52px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-overflow-scrolling: touch;
  .e-preview-header{
    color: white;
    text-align: center;
    padding: 0 20px;
    padding-bottom: 30px;
    background-size: cover;
    .title{
      padding-top: 50px;
      font-size: 24px;
      line-height: 32px;
      font-weight: 700;
    }
    .desc{
      font-size: 13px;
      line-height: 22px;
      opacity: .75;
      margin-bottom: 25px;
    }
    .btn-group{
      display: flex;
      justify-content: center;
      a{
        width: 160px;
        height: 45px;
        font-size: 14px;
        line-height: 45px;
        font-weight: 700;
        text-align: center;
        border-radius: 3px;
      }
      .join{
        background-color: #FE5454;
        color: #fff;
        margin-right: 15px;
      }
      .contact{
        color: #FE5454;
        background-color: #fff;
      }
    }
  }
  .e-preview-fast{
    height: 60px;
    line-height: 60px;
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
    li{
      display: inline-block;
      margin-right: 25px;
      font-size: 14px;
      &:nth-last-child(1){
        margin-right: 0;
      }
    }
  }
  .e-preview-imgs{
    padding-bottom: 50px;
    li{
      img{
        width: 100%;
        vertical-align: top;
      }
    }
  }
  .e-preview-price{
    width: 100%;
    height: 50px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    box-shadow: 0px -3px 3px 1px rgba($color: #C6CACE, $alpha: 0.16);
    transform: translate3d(0, 100%, 0);
    transition: transform .3s;
    &.show{
      transform: translate3d(0, 0%, 0);
    }
    .info{
      position: absolute;
      left: 0;
      bottom: 0;
      height: 50px;
      margin-right: 160px;
      .title{
        padding-left: 17px;
        padding-top: 7px;
        line-height: 16px;
        font-size: 12px;
        margin-bottom: 2px;
      }
      .price{
        line-height: 19px;
        font-size: 14px;
        padding-left: 17px;
        color: #FE5454;
      }
    }
    .join{
      position: absolute;
      width: 160px;
      height: 50px;
      right: 0;
      bottom: 0;
      background: #FE5454;
      color: white;
      text-align: center;
      line-height: 50px;
      font-size: 16px;
      font-weight: 700;
    }
  }
}
</style>

<style lang="scss">
.e-preview-header.m{
  .plan-group{
    font-size: 20px;
    display: flex;
    justify-content: center;
    margin-bottom: 35px;
    li{
      display: inline-block;
      padding: 0 25px;
      border-right: 1px solid rgba(255, 255, 255, .16);
      &:nth-child(1) {
        border-right: none;
      }
      p:nth-child(1){
        font-size: 12px;
        line-height: 16px;
        opacity: .75;
        margin-bottom: 4px;
      }
      p:nth-child(2){
        font-size: 18px;
        line-height: 24px;
      }
    }
  }
  .logo-group{
    margin-top: 24px;
    margin-bottom: 5px;
    p{
      line-height: 20px;
      font-size: 14px;
      color: #fff;
      opacity: .3;
    }
    li{
      display: inline-block;
      height: 32px;
      img{
        height: 100%;
        width: auto;
      }
    }
  }
}
</style>

<style lang="scss">
.e-preview-dialog.m{
  img{
    width: 100%;
    height: auto;
  }
}
</style>

